
const digest = '55578b6ac974996fbb3ca8fddaa9f27dfd4f876c13c11b0059815d1c317dfcdf';
const classes = {"wrapper":"_wrapper_1tiv8_1","selectWrapper":"_selectWrapper_1tiv8_7","calendarWrapper":"_calendarWrapper_1tiv8_12"};
const css = `._wrapper_1tiv8_1 {
  height: calc(100vh - 84px);
  position: relative;
  display: flex;
  flex-direction: column;
}
._wrapper_1tiv8_1 ._selectWrapper_1tiv8_7 {
  position: relative;
  width: 100%;
  z-index: 100;
}
._wrapper_1tiv8_1 ._calendarWrapper_1tiv8_12 {
  flex-grow: 1;
  position: relative;
  overflow-y: scroll;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  